import {
    Component,
    OnInit,
    ComponentRef,
    OnDestroy,
    HostListener
} from '@angular/core';
import { ShoppingCartService } from './services/shopping-cart.service';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from './services/common.service';
import { ShoppingCart } from './models/shopping-cart.model';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { AuthService } from './services/auth.service';
import { takeUntil } from 'rxjs/operators';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.css',
    ]
    // host: {'(document:click)': 'onClick($event)'}
})
export class AppComponent implements OnInit, OnDestroy {
    // @ViewChild('entry', { read: ViewContainerRef })
    // entry: ViewContainerRef;

    hasUser = false;

    component: ComponentRef<any>;

    collapseMenu = false;
    toggleUser = false;
    toggleNotification = false;

    toggleCreateHelp = false;
    tourStart = false;
    breadcumb = false;

    // css style
    togglehelp = false;
    toggleSetting = false;

    // close event
    closesub$;

    subscription: Subscription;
    private ngUnsubscribe = new Subject<void>();
    loading = false;


    constructor(
        private shoppingCartService: ShoppingCartService,
        private commonService: CommonService,
        private authService: AuthService,
        private router: Router
    ) { }

    @HostListener('document:click', ['$event'])
    documentClick(event: MouseEvent) {
        $('#resetToggle').click();
    }

    ngOnInit(): void {
        this.tourStart = false;

        //check for update
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then(function (registration) {
                registration.update();
            });
        }

        this.router.events
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (!event.url.includes('home')) {
                        this.tourStart = false;
                        this.commonService.monitorStepChange('');
                    }



                    this.loading = true;
                } else if (
                    event instanceof NavigationEnd ||
                    event instanceof NavigationCancel ||
                    event instanceof NavigationError
                ) {
                    // Navigation has finished (successfully, cancelled, or with an error)
                    this.loading = false;
                }
            });

        // this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
        //     res.source = 'DDWEBSITE';
        //     res.source = 'SAP';
        // });

        this.commonService.currentStep.subscribe((res: string) => {
            if (res) {
                this.tourStart = true;
            } else {
                this.tourStart = false;
            }
        },
            (error: any) => {
                console.error(error);
            });

        if (!this.commonService.readCookie('CartId') || !this.commonService.readCookie('CompanyCode')) {
            this.shoppingCartService.getShoppingCart().subscribe((res: ShoppingCart[]) => {
                if (res && res.length) {
                    this.shoppingCartService.monitorCartId(res[0].cartId);
                    this.commonService.createCookie('CartId', res[0].cartId.toString(), 7);
                    this.commonService.createCookie('CompanyCode', res[0].companyCode, 7);
                } else {
                    this.shoppingCartService.monitorCartId(this.shoppingCartService.initialShoppingCart());
                }
            },
                (error: any) => {
                    console.error(error);
                });
        } else {
            this.shoppingCartService.monitorCartId(this.commonService.toNumber(this.commonService.readCookie('CartId')));
        }

    }

    getCollapseMenu(): boolean {
        const match = document.cookie.match(new RegExp('(^| )collapseMenu=([^;]+)'));
        const collapseMenu = match ? match[2] : null;
        return collapseMenu != null ? collapseMenu == "true" : false;
    }
 
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
